import { LoadSpinner } from '@calizahq/react-components-v2'
import { Table } from '@shared/components'
import React, { useMemo } from 'react'

import { NoResults } from '@/components'
import { useMobile } from '@/hooks'
import { AccessInstruction } from '@/types/Homes'

import { AccessInstructionListColumns } from './AccessInstruction.data'
import { AccessInstructionMobileCard } from './AccessInstructionMobileCard'

type Props = {
  data: AccessInstruction[]
  handleEditInstruction: (accessInstruction: AccessInstruction) => void
  isEditable: boolean
  isLoading: boolean
}

export const AccessInstructions = ({ data, handleEditInstruction, isEditable, isLoading }: Props) => {
  const { isTablet } = useMobile()

  const columns = useMemo(() => {
    return AccessInstructionListColumns(handleEditInstruction, isEditable)
  }, [handleEditInstruction, isEditable])

  return (
    <div className="flex w-full flex-col">
      {isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isTablet ? (
            <>
              {data?.map((accessInstruction, index) => (
                <AccessInstructionMobileCard
                  accessInstruction={accessInstruction}
                  handleEditInstruction={handleEditInstruction}
                  key={index}
                />
              )) || <NoResults />}
            </>
          ) : (
            <Table columns={columns as any} data={data} />
          )}
        </>
      )}
    </div>
  )
}

export function NoInstructions() {
  return (
    <div className="flex w-full flex-col p-4">
      <p className="text-p-sm italic text-secondary">No Information Available</p>
    </div>
  )
}
